import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import SELECT_PHONE from "../reuseable/Dropdown/SELECT_PHONE";
import countries_code from "../../Data/countries_code.json";

const parsePhone = (val) => {
  const strVal = String(val || "").replace(/[^0-9]/g, "");
  if (!strVal) return { cCode: "62", pNum: "" };
  let matchCode = "62";
  let maxLen = 0;
  countries_code.forEach((c) => {
    const code = String(c.phone_code);
    if (strVal.startsWith(code) && code.length > maxLen) {
      matchCode = code;
      maxLen = code.length;
    }
  });
  return { cCode: matchCode, pNum: strVal.slice(matchCode.length) };
};

export default function C_E_PHONE({
  tempValue,
  onChange,
  onBlur,
  onKeyDown,
  inPopup = false,
}) {
  const [countryCode, setCountryCode] = useState("62");
  const [phoneNumber, setPhoneNumber] = useState("");
  const phoneInputRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);
  const properties_state = useSelector((state) => state.properties);

  // Initialize the split values when the editor mounts
  useEffect(() => {
    const { cCode, pNum } = parsePhone(tempValue);
    setCountryCode(cCode);
    setPhoneNumber(pNum);
  }, [tempValue]);

  // Auto focus the input field on mount (ONLY in Table Mode)
  useEffect(() => {
    if (!inPopup && phoneInputRef.current) {
      phoneInputRef.current.focus();
    }
  }, [inPopup]);

  const handleNumberChange = (e) => {
    const num = e.target.value.replace(/[^0-9]/g, "");
    setPhoneNumber(num);
    onChange({ target: { value: `${countryCode}${num}` } });
  };

  const handleCodeChange = (newCode) => {
    setCountryCode(newCode);
    onChange({ target: { value: `${newCode}${phoneNumber}` } });
    setTimeout(() => {
      if (phoneInputRef.current) {
        phoneInputRef.current.focus();
      }
    }, 10);
  };

  // Shared Blur Logic (handles portal clicks for the dropdown)
  const handleLocalBlur = (e) => {
    const currentTarget = e.currentTarget;
    setTimeout(() => {
      const active = document.activeElement;
      if (currentTarget.contains(active)) return;

      const isInsidePortal =
        active &&
        active.closest &&
        active.closest(".select-phone-portal-container");

      if (isInsidePortal) return;
      if (active === document.body || active === null) return;

      if (inPopup) setIsFocused(false);
      if (onBlur) onBlur(e);
    }, 0);
  };

  // Shared KeyDown Logic (prevents grid nav collision)
  const handleLocalKeyDown = (e) => {
    const allowedKeys = [
      "ArrowUp",
      "ArrowDown",
      "ArrowLeft",
      "ArrowRight",
      "Escape",
      "Enter",
      " ",
    ];
    if (!allowedKeys.includes(e.key)) {
      e.stopPropagation();
    }
    if (onKeyDown) onKeyDown(e);
  };

  // 1. POPUP MODE
  if (inPopup) {
    const mode_map = properties_state.mode_map; //editor || viewer
    //tempValue
    const { cCode, pNum } = parsePhone(tempValue);
    const formattedPNum = pNum ? pNum.replace(/(\d{3})(?=\d)/g, "$1-") : "";
    const displayPhone = `+${cCode}-${formattedPNum}`;

    return (
      <div>
        {mode_map === "editor" ? (
          <>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
                width: "100%",
                padding: "8px",
                border: "1px solid #ccc",
                boxSizing: "border-box",
                backgroundColor: "#fff",
              }}
              tabIndex={-1}
              onBlur={handleLocalBlur}
              onKeyDown={handleLocalKeyDown}
              onFocus={() => setIsFocused(true)}
            >
              <div
                style={{
                  flexShrink: 0,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <SELECT_PHONE
                  filter_on={true}
                  value={countryCode}
                  options={countries_code}
                  onChange={handleCodeChange}
                />
              </div>
              <input
                ref={phoneInputRef}
                type="text"
                inputMode="numeric"
                className="input_table"
                value={phoneNumber}
                onChange={handleNumberChange}
                style={{
                  width: "100%",
                  outline: "none",
                  border: "none",
                  background: "transparent",
                }}
              />
            </div>
            {isFocused && (
              <p className="text_small sub_color margin_top_small">
                Press Enter to save
              </p>
            )}
          </>
        ) : (
          <div className="container background_white text_medium">
            {displayPhone}
          </div>
        )}
      </div>
    );
  }

  // 2. TABLE EDIT MODE
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "4px",
        width: "100%",
        height: "100%",
        padding: "0 4px",
        boxSizing: "border-box",
      }}
      onClick={(e) => e.stopPropagation()}
      tabIndex={-1}
      onBlur={handleLocalBlur}
      onKeyDown={handleLocalKeyDown}
    >
      <div
        style={{
          flexShrink: 0,
          height: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        <SELECT_PHONE
          filter_on={true}
          value={countryCode}
          options={countries_code}
          onChange={handleCodeChange}
        />
      </div>
      <input
        ref={phoneInputRef}
        type="text"
        inputMode="numeric"
        className="input_table"
        value={phoneNumber}
        onChange={handleNumberChange}
        style={{
          width: "100%",
          height: "100%",
          outline: "none",
          border: "none",
          background: "transparent",
        }}
      />
    </div>
  );
}
